import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ICustomerUser } from '@care-portals/api-interfaces';
import { AdminUserFacade } from '../../../+store/admin-user/admin-user.facade';
import { takeWhile } from 'rxjs/operators';
import { CustomerFacade } from '../../../+store/customer/customer.facade';
import { combineLatest } from 'rxjs';

type User = {
  name: string;
  roles: string[];
  id: string;
  email: string;
  username: string;
};

@Component({
  selector: 'my-health-admin-watchlist-manager',
  templateUrl: './watchlist-manager.component.html',
  styleUrls: ['./watchlist-manager.component.less']
})
export class WatchlistManagerComponent implements OnInit, OnDestroy {
  customer: ICustomerUser;
  isSaving$ = this.customerFacade.saving$;
  isActive = true;
  selectedUserId: string;
  watchers: User[] = [];
  allUsers: User[] = [];

  constructor(
    private adminUserFacade: AdminUserFacade,
    private customerFacade: CustomerFacade
  ) {}

  ngOnInit() {
    combineLatest([
      this.customerFacade.selectedCustomer$,
      this.adminUserFacade.adminUsers$
    ])
      .pipe(takeWhile(() => this.isActive))
      .subscribe(([customer, users]) => {
        this.customer = customer;

        this.allUsers = users.map(u => ({
          email: u.email,
          id: u._id,
          name: `${u.firstName} ${u.lastName}`,
          roles: u.role.split('-'),
          username: u.username
        }));

        this.watchers = this.allUsers.filter(u =>
          this.customer.watchlist?.includes(u.id)
        );

        this.selectedUserId = null;
      });
  }

  unWatch(userId: string) {
    this.customerFacade.updateWatchlist(false, userId);
  }

  watch(userId: string) {
    this.customerFacade.updateWatchlist(true, userId);
  }

  ngOnDestroy() {
    this.isActive = false;
  }
}
